import { Styles } from 'common/lib/material-ui/theme';

export const counter: Styles = {
  mt: 1,
  fontSize: 14,
  color: 'optional.main',
};
